import {
  InputType,
  SinglePageApplicationResponse,
  SinglePageApplicationListResponse,
  TargetType,
} from '../../types/project/Application';
import Axios from 'axios';
import URL from '../../config/url';

export async function getSinglePageApplicationById({
  spaId,
  applicationId,
}: {
  spaId?: string;
  applicationId: string;
}) {
  return Axios.get<SinglePageApplicationResponse>(URL.SPA_GET, {
    params: {
      applicationId,
      spaId,
    },
  });
}

export async function getSinglePageApplicationsByApplicationId({
  applicationId,
}: {
  applicationId: string;
}) {
  return Axios.get<SinglePageApplicationListResponse>(
    URL.APPLICATION_SPA_LIST(applicationId, 'TEST')
  );
}

export async function getOrCreateSinglePageApplication({
  projectId,
  applicationId,
  deploymentId,
  inputType,
  targetType,
}: {
  projectId: string;
  applicationId: string;
  deploymentId?: string;
  inputType: InputType;
  targetType: TargetType;
}) {
  const params = deploymentId
    ? {
        projectId,
        applicationId,
        inputType,
        targetType,
        deploymentId,
      }
    : {
        projectId,
        applicationId,
        inputType,
        targetType,
      };
  return Axios.get<SinglePageApplicationResponse>(URL.SPA_GET_OR_CREATE, {params});
}
